import {Desk, EmployeeRef, INeighbourhood} from "../../../api/Model";
import {isLowAttendance} from "../../../util/visit/LowAttendance";
import {combineCmp, naturalCmpOptions, numberCmp, stringCmp} from "../../../util/SortUtil";
import {DeskModel} from "../../desks/DeskModel";
import {mapNotNull} from "../../../util/ArrayUtil";
import {Opt} from "../../../util/Optional";

export type DeskAssignedToLowAttendanceEmployee = {
    desk: Desk,
    employee: EmployeeRef,
    neighbourhood: Opt<INeighbourhood>,
    visits: {
        workDayVisits: number,
        tenureDayCount: number,
        percent: number,
    },
};

export function findDesksAssignedToLowAttendanceEmployees(
    deskModel: DeskModel,
    desks: Desk[],
): DeskAssignedToLowAttendanceEmployee[] {
    return mapNotNull(desks, desk => {
        const visitStats = deskModel.employeeVisitStats(desk);
        if (!visitStats) return null;

        if (!isLowAttendance(visitStats.stats)) return null;

        return {
            desk,
            employee: visitStats.employee,
            neighbourhood: deskModel.neighbourhood(desk),
            visits: visitStats.stats,
        };
    })
        .sort(combineCmp(
            numberCmp(row => row.visits.percent),
            stringCmp(row => row.employee.fullName),
            stringCmp(row => row.desk.name, false, naturalCmpOptions),
        ));
}
